import { Link, useLocation } from "react-router-dom";
import { PlayCircle } from "lucide-react";
import YoutubeThumbnail from "./YoutubeThumbnail";

function PublicInsightCardPreview({ type, previewImage, previewVideoId, previewAlt, title }) {
  const imageSrc = previewImage || null;

  if (imageSrc || previewVideoId) {
    return (
      <div className="jw-public-insight-card__preview">
        {imageSrc ? (
          <img src={imageSrc} alt={previewAlt || title} loading="lazy" decoding="async" />
        ) : (
          <YoutubeThumbnail videoId={previewVideoId} alt={previewAlt || title} />
        )}
        {type === "Video" ? (
          <span className="jw-public-insight-card__preview-play" aria-hidden="true">
            <PlayCircle className="jw-public-icon-lg" />
          </span>
        ) : null}
      </div>
    );
  }

  if (type === "Video") {
    return (
      <div className="jw-public-insight-card__preview jw-public-insight-card__preview--placeholder">
        <PlayCircle className="jw-public-icon-lg" aria-hidden="true" />
        <span>Video</span>
      </div>
    );
  }

  return null;
}

export default function PublicInsightCard({
  type,
  title,
  copy,
  href,
  previewImage,
  previewVideoId,
  previewAlt,
}) {
  const location = useLocation();
  const cardContent = (
    <>
      <PublicInsightCardPreview
        type={type}
        previewImage={previewImage}
        previewVideoId={previewVideoId}
        previewAlt={previewAlt}
        title={title}
      />
      <div className="jw-public-insight-card__body">
        <span className="blog-meta">{type}</span>
        <h3>{title}</h3>
        <p>{copy}</p>
      </div>
    </>
  );

  if (href) {
    return (
      <Link
        className="blog-card jw-public-card jw-public-insight-card jw-public-insight-card--link"
        to={href}
        state={{ from: location.pathname }}
      >
        {cardContent}
      </Link>
    );
  }

  return (
    <article className="blog-card jw-public-card jw-public-insight-card">
      {cardContent}
    </article>
  );
}
